const Report = () =>
  import(
    /* webpackChunkName: "feedback-feedback" */ '@/pages/feedback/feedback/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "feedback-feedback" */ '@/pages/feedback/feedback/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "feedback-feedback" */ '@/pages/feedback/feedback/edit.vue'
  )

const Detail = () =>
  import(
    /* webpackChunkName: "feedback-feedback" */ '@/pages/feedback/feedback/detail.vue'
  )

export default {
  path: 'feedback',
  meta: {
    label: 'feedback',
    auth: 'feedback'
  },
  component: {
    name: 'Feedback',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FeedbackReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FeedbackCreate',
      path: 'create/:orderId/:customerId',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create,
      props: true
    },
    {
      name: 'FeedbackEdit',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    },
    {
      name: 'FeedbackDetail',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: true
      },
      component: Detail,
      props: true
    }
  ]
}
